import {TYPE_SALARY_CONFIG} from "../item/typeSalaryConfig";
import {ImportOutlined, PlusOutlined, StarOutlined} from "@ant-design/icons";
import React from "react";

export const columnPayrollCustom = (t) => {
    return [
        {
            title: t('tnp.components.salary.text140'),
            dataIndex: 'creatorName',
            key: 'creatorName',
        },
        {
            title: t("tnp.components.salary.payrollPeriodStartDate"),
            dataIndex: 'payrollPeriodStartDate',
            key: 'payrollPeriodStartDate',
        },
        {
            title: t("tnp.components.salary.payrollPeriodEndDate"),
            dataIndex: 'payrollPeriodEndDate',
            key: 'payrollPeriodEndDate',
        },
        {
            title: t('tnp.components.salary.text141'),
            dataIndex: 'salaryName',
            key: 'salaryName',
        },
        {
            title: t('tnp.components.salary.text142'),
            dataIndex: 'isClose',
            key: 'isClose',
        },
        {
            title: t('tnp.components.salary.text143'),
            dataIndex: 'departmentName',
            key: 'departmentName',
        },
        {
            title: t('tnp.components.salary.text144'),
            dataIndex: 'positionName',
            key: 'positionName',
        },
        {
            title: t('tnp.components.salary.text145'),
            dataIndex: 'totalEmployee',
            key: 'totalEmployee',
            align: 'right',
        },
        {
            title: t('tnp.components.salary.text146'),
            dataIndex: 'totalSalary',
            key: 'totalSalary',
            align: 'right',

        },
        {
            title: t('tnp.components.salary.text147'),
            dataIndex: 'createDate',
            key: 'createDate',
        },
        {
            dataIndex: 'menu',
            width: '9%',
            align: 'right'
        }
    ]
}

export function getTypeSalary(type,t) {
    if (type === TYPE_SALARY_CONFIG.import)
        return t('tnp.components.salary.text138')
    else if (type === TYPE_SALARY_CONFIG.main)
        return t('tnp.components.salary.text139')
    else if (type === TYPE_SALARY_CONFIG.extra)
        return t('tnp.components.salary.text213')

    return ''
}

export function getIconFromType(type) {
    if (type === TYPE_SALARY_CONFIG.import) return <ImportOutlined />
    else if (type === TYPE_SALARY_CONFIG.main) return <StarOutlined />
    else if (type === TYPE_SALARY_CONFIG.extra) return <PlusOutlined />

    return ''
}